import { Component } from 'preact';

export default class MapLegend extends Component {
  render () {
    return <div class="MapLegend">
      <h3 class="title">Deaths</h3>

      <svg height="7">
        <rect x="0" y="0" width="16.67%" height="100%" fill="#ADB7C2" />
        <rect x="16.67%" y="0" width="16.67%" height="100%" fill="#051966" />
        <rect x="33.33%" y="0" width="16.67%" height="100%" fill="#45B5E5" />
        <rect x="50%" y="0" width="16.67%" height="100%" fill="#F1B433" />
        <rect x="66.67%" y="0" width="16.67%" height="100%" fill="#F28430" />
        <rect x="83.33%" y="0" width="16.67%" height="100%" fill="#ED4630" />
      </svg>

      <ul class="labels">
        <li>0</li>
        <li>1</li>
        <li>2-3</li>
        <li>4-20</li>
        <li>21-50</li>
        <li>51+</li>
      </ul>
    </div>
  }
}



// WEBPACK FOOTER //
// ./components/MapLegend.js